import { createSelector } from 'reselect';

const selectEnhanceUserRoles = (state: any) => state.enhanceUserRoles;


export const selectEnhanceUserRolesCurrentItem = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.current);

export const selectEnhanceUserRolesListItems = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectEnhanceUserRolesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEnhanceUserRolesQueryItems = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.query);

export const selectEnhanceUserRolesCreatedItem = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.create);

export const selectEnhanceUserRolesUpdatedItem = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.update);

export const selectEnhanceUserRolesReadItem = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.read);

export const selectEnhanceUserRolesDeletedItem = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.delete);

export const selectEnhanceUserRolesSearchedItems = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.search);

export const selectEnhanceUserRolesItemsCount = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.count);

export const selectEnhanceUserRolesItemsFilter = createSelector([selectEnhanceUserRoles], (enhanceUserRoles) => enhanceUserRoles.filter);